/* FJC 2026-10-15: Black Friday Exclusive announcement strip + sign-up modal
   (sections/fjc-bf-announcement.liquid).
   - [data-fjc-bf-open] opens the modal (the strip's "Join the list"; any other element with the
     attribute, e.g. a ribbon item, works too). Without JavaScript the link goes to the landing page.
   - Close: the X, Escape, and the CONTINUE SHOPPING button on the Klaviyo form's success step
     (its Klaviyo action is "Close form", Marija 19 Oct; the click is taken in the capture phase so
     Klaviyo never runs its own close, which would blank the embedded form for a later reopen).
     Focus moves to the close button on open and back to the trigger on close.
   - The strip is hidden (next page load, and at once) after a sign-up in this browser: see
     assets/fjc-bf-signup-form.js, which sets localStorage fjcBfSignedUp on Klaviyo's submit event.
   - The modal is moved to <body> so the header's stacking contexts cannot trap the fixed overlay.
   - window.fjcBfSignup.open() / .close() for other triggers. */
(function () {
  'use strict';

  var api = window.fjcBfSignup = window.fjcBfSignup || {};
  var modal = null;
  var lastTrigger = null;
  var closeTimer = null;
  var onCloseEnd = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function findModal() {
    var el = document.querySelector('[data-fjc-bf-modal]');
    if (el && el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    return el;
  }

  function isOpen() {
    return !!(modal && modal.classList.contains('is-open'));
  }

  function cancelPendingClose() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (onCloseEnd && modal) { modal.removeEventListener('transitionend', onCloseEnd); onCloseEnd = null; }
  }

  function open(trigger) {
    modal = findModal();
    if (!modal) return;
    // reopening while the slide-out is still running: keep it, do not let the pending
    // close hide it under the open state (that left the modal invisible and the page locked)
    cancelPendingClose();
    if (isOpen()) return;
    lastTrigger = trigger || null;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fjc-drawer-open');
    // a forced reflow between un-hiding and the class, so the slide-in transition runs
    // (synchronous, unlike requestAnimationFrame, so two quick clicks cannot interleave)
    void modal.offsetWidth;
    modal.classList.add('is-open');
    var dialog = modal.querySelector('.fjc-bf-modal__dialog');
    if (dialog) dialog.scrollTop = 0;
    var close = modal.querySelector('[data-fjc-bf-close]');
    if (close) close.focus();
  }

  function close() {
    if (!isOpen()) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fjc-drawer-open');
    var done = function () {
      cancelPendingClose();
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    };
    // only the overlay's own transform transition, not a button's hover transition bubbling up
    onCloseEnd = function (e) { if (e.target === modal) done(); };
    modal.addEventListener('transitionend', onCloseEnd);
    closeTimer = setTimeout(done, 400);
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  api.open = open;
  api.close = close;

  // Klaviyo's success step: the CONTINUE SHOPPING button inside the modal closes the modal
  var FORM_CLOSE_LABEL = /^\s*continue\s+shopping\s*$/i;

  function isFormCloseButton(target) {
    if (!isOpen()) return false;
    var button = target.closest('button, a');
    if (!button || !modal.contains(button) || !button.closest('[class*="klaviyo-form"]')) return false;
    return FORM_CLOSE_LABEL.test(button.textContent);
  }

  function modalFormId() {
    var embed = modal && modal.querySelector('[class*="klaviyo-form-"]');
    var m = embed && embed.className.match(/klaviyo-form-([A-Za-z0-9]+)/);
    return m ? m[1] : null;
  }

  // capture phase: runs before any other click handler on the page, so nothing else can
  // navigate the link or swallow the click
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-fjc-bf-open]');
    if (opener) {
      if (findModal()) {
        e.preventDefault();
        e.stopPropagation();
        open(opener);
      }
      return;
    }

    if (target.closest('[data-fjc-bf-close]')) {
      e.preventDefault();
      close();
      return;
    }

    if (isFormCloseButton(target)) {
      // stop here: Klaviyo's "Close form" would otherwise remove the embedded form
      e.preventDefault();
      e.stopPropagation();
      close();
    }
  }, true);

  // If Klaviyo does run its own close for this form (e.g. the button was renamed), follow it
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || d.type !== 'close' || !isOpen()) return;
    var id = modalFormId();
    if (id && d.formId && d.formId !== id) return;
    close();
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab') {
      // keep focus inside the modal
      var items = Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Theme editor: the section is re-rendered on every setting change; the copy moved to <body>
  // would otherwise go stale and double up.
  document.addEventListener('shopify:section:load', function () {
    var copies = document.querySelectorAll('[data-fjc-bf-modal]');
    if (copies.length > 1) {
      Array.prototype.forEach.call(copies, function (el) {
        if (el.parentElement === document.body) el.remove();
      });
    }
    modal = findModal();
  });

  modal = findModal();
})();
